import { LinearProgress, Stack } from "@mui/material";
import { FC } from "react";
import { ExplainWithAiLoading } from "@/components/common/explain-with-ai-drawer/components/common/ExplainWithAiLoading";

export const InfrastructureArchitectureRecommendationPanelLoading: FC = () => {
  return (
    <Stack
      pt={0.75}
      mx={2}
      spacing={0.5}
      borderRadius={2}
      alignItems="center"
      bgcolor="grey.100"
      justifyContent="center"
    >
      <ExplainWithAiLoading iconSize="medium" />
      <LinearProgress sx={linearProgressStyles} />
    </Stack>
  );
};

const linearProgressStyles = {
  width: "100%",
  borderBottomLeftRadius: 8,
  borderBottomRightRadius: 8,
};
